/* eslint-disable @typescript-eslint/no-explicit-any */
import { Table as AntTable, TableProps, Spin } from 'antd';
import React, { FC } from 'react';
import './styles.scss';

type GenericObject = { [key: string]: unknown };

export interface ITable extends TableProps<any> {
  columns: GenericObject[];
  data: any[];
  isLoading?: boolean;
  rowKey?: string;
  variant?: 'dark' | 'light';
  onChangeColumnOrder?: (order: string) => void;
}

const Table: FC<ITable> = ({
  columns,
  data,
  isLoading = false,
  rowKey = 'id',
  variant = 'light',
  onChangeColumnOrder,
  ...rest
}) => {
  return (
    <Spin spinning={isLoading}>
      <AntTable
        {...rest}
        columns={columns}
        className={`hbh-table ${variant && `hbh-table-${variant}`}`}
        dataSource={data}
        pagination={false}
        rowKey={rowKey}
        onChange={(_: any, _2: any, sorter: any) => {
          const order = `${sorter.order === 'descend' ? '-' : ''}${sorter.columnKey}`;
          onChangeColumnOrder && onChangeColumnOrder(order);
        }}
      />
    </Spin>
  );
};

export default Table;
